export enum SaleSegment {
  RESIDENTIAL = 'residential',
  BUSINESS = 'business',
}

export enum CustomerSegment {
  RESIDENTIAL = 'Particular',
  FREELANCE = 'Autónomo',
  COMPANY = 'Empresa',
}
